<template>
  <div id="app">

    <app-header></app-header>

    <menu-page v-if="activeScreen == 'menu'"></menu-page>

    <game-page v-if="activeScreen == 'game'"></game-page>

  </div>
</template>

<script>
  import AppHeader from "./components/AppHeader";
  import MenuPage from "./pages/MenuPage";
  import GamePage from "./pages/GamePage";

export default {
  name: 'App',
  components: {
    AppHeader,
    MenuPage,
    GamePage,
  },
  computed: {
    activeScreen() {
      return this.$store.state.screen;
    }
  },
}
</script>

<style lang="scss">

</style>
